// extracted by mini-css-extract-plugin
module.exports = {"heading":"SelectCategory_heading__raVpd","editIcons":"SelectCategory_editIcons__2DHXF"};